<template>
  <div class="searchbar--wrapper">
    <span class='icon searchbar--icon yule-icon-search'/>
    <input
      class="searchbar--input"
      ref="searchbar"
      type="text"
      :placeholder="computedPlaceholder"
      v-model="term"
    />
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: true
    },
    shouldFocus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedPlaceholder() {
      return this.$t(`ui.searchbar.placeholder.${this.placeholder}`)
    }
  },
  data() {
    return {
      term: null
    }
  },
  mounted() {
    this.$refs.searchbar.focus()
  },
  methods: {
    search() {
      this.$emit('search', this.term)
    }
  },
  watch: {
    term() {
      this.search()
    },
    shouldFocus(val) {
      if (val) {
        this.$refs.searchbar.focus()
        this.$emit('shouldFocusChange')
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.searchbar--wrapper
  display: flex

.searchbar--icon
  position: relative
  width: 24px
  font-size: 1.6em
  color: $grey
  cursor: pointer
  align-self: flex-start
  margin-right: .5em

.searchbar--input
  display: block
  width: 100%
  background: transparent
  padding: 0.5em
  font-size: 1em
  border: none
  color: $onyx-light
  &:focus, &:active
    outline: none
  &::placeholder
    color: $grey
    font-weight: 400
</style>



// WEBPACK FOOTER //
// AssignmentModalSearchBar.vue?7acc9f88